<app-form-editors
    (onValidate)="validate($event)"
    (onCancel)="cancel()">
</app-form-editors>
